<div class="toggle-switch-container">   @if (label || description) {
    <div class="toggle-switch-content">
      <div class="toggle-switch-text">
        @if (label) {
          <label class="toggle-switch-label">{{ label }}</label>
        }
        @if (description) {
          <p class="toggle-switch-description">{{ description }}</p>
        }
      </div>
    </div>
  }

  <div class="toggle-switch-wrapper">
    <label class="toggle-switch" [class.disabled]="disabled">
      <input
        type="checkbox"
        [id]="id"
        [checked]="value"
        [disabled]="disabled"
        (change)="onToggle()"
      />
      <span class="toggle-slider"></span>
    </label>
  </div>
</div>
